// src/pages/GameDetail.js
import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getAllGamesSync } from "../data/allGames";   // ⭐ FIXED
import Badge from "../components/Badge";
import Button from "../components/Button";
import {
  FaLink,
  FaChrome,
  FaAndroid,
  FaApple,
  FaDesktop,
} from "react-icons/fa";

const PLATFORM_ICON_MAP = {
  web: FaChrome,
  android: FaAndroid,
  ios: FaApple,
  pc: FaDesktop,
};

export default function GameDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const allGames = getAllGamesSync();                 // ⭐ FIXED
  const game = allGames.find((g) => String(g.id) === String(id));

  if (!game) {
    return (
      <div className="grid gap-4">
        <p className="text-slate-300 mb-4">Game not found.</p>
        <Link
          to="/"
          className="text-emerald-300 underline text-sm hover:text-emerald-200"
        >
          ← Back to directory
        </Link>
      </div>
    );
  }

  const {
    title,
    image,
    description,
    genre,
    isWeb3,
    platforms = [],
    tags = [],
    source,
    webglPath,
  } = game;

  const canPlayHere = !!webglPath;

  return (
    <div className="grid gap-6">

      {/* TOP BAR */}
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
        <Link
          to="/"
          className="px-3 py-2 rounded-xl border border-slate-700 text-sm text-slate-200 hover:border-emerald-400 hover:text-emerald-200 transition"
        >
          ← Back to directory
        </Link>
      </div>

      <div className="flex flex-col md:flex-row gap-6">

        {/* IMAGE */}
        <div className="w-full md:w-1/3 rounded-2xl overflow-hidden border border-slate-800 bg-slate-900">
          {image ? (
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-48 flex items-center justify-center text-slate-500 text-sm">
              No image available
            </div>
          )}
        </div>

        {/* INFO */}
        <div className="flex-1 flex flex-col gap-3 min-w-0">

          <div className="flex items-start justify-between gap-3 flex-wrap">
            <div className="min-w-0">
              <p className="text-sm text-slate-400 mb-1">{source}</p>

              <div className="flex items-center gap-3 flex-wrap">

                {isWeb3 && (
                  <span className="inline-flex items-center gap-1 text-emerald-300 text-sm">
                    <FaLink />
                    <span>Web3 game</span>
                  </span>
                )}

                {platforms.length > 0 && (
                  <div className="flex flex-wrap items-center gap-2 text-xs text-slate-200">
                    {platforms.map((p) => {
                      const Icon = PLATFORM_ICON_MAP[p] || FaDesktop;
                      return (
                        <span
                          key={p}
                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-800 uppercase tracking-wide"
                        >
                          <Icon className="text-[13px]" />
                          {p}
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <Badge>{genre}</Badge>
          </div>

          {/* DESCRIPTION */}
          <p className="text-slate-200 text-sm md:text-base">{description}</p>

          {/* TAGS */}
          {tags.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-1">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2 py-1 rounded-full bg-slate-800 text-xs text-slate-100"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}

          {/* ACTION BUTTON */}
        <div className="mt-4 flex flex-wrap gap-3 items-center">

  {/* Play on-site */}
  {canPlayHere && (
    <Button
      onClick={() => navigate(`/play/${id}`)}
      className="bg-emerald-500 text-white hover:bg-emerald-400 px-5 py-2.5 rounded-xl text-sm font-semibold"
    >
      Play Here
    </Button>
  )}

  {!canPlayHere && (
    <span className="text-xs text-slate-400">
      This game isn&apos;t playable directly on this site.
    </span>
  )}

  {/* ⭐ GOOGLE PLAY BUTTON */}
{game.googlePlayUrl && (
  <a
    href={game.googlePlayUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-block"
  >
    <img
      src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
      alt="Get it on Google Play"
      className="h-12 w-auto"
    />
  </a>
)}



        <div className="spacer" style={{height: 150}}></div>


</div>


        </div>
      </div>
    </div>
  );
}
